class PopupController {
    /*@ngInject*/
    constructor($mdDialog, title, label, content) {
        "ngInject";
    	this.$mdDialog = $mdDialog;
        this.data = {};
        this.data.title = title;
        this.data.label = label;
        this.data.content = content;
    }

    ok() {
    	this.$mdDialog.hide(this.selectedItem);
    }
}

export default PopupController;



// WEBPACK FOOTER //
// ./client/app/common/popup.component/popup.controller.js